export class ContactFileInformationDc {
    public ContactFileId: Number;
    public ContactId: Number;
    public ContactTypeId?: Number;
    public AuthenticationId: number;
    public AccountManagerId: number;
    public CaseManagerId: number;
    public CreditAdvisorId: number;
    public Affiliate1: number;
    public Affiliate2: number;
    public Affiliate3: number;
    public Affiliate1Name: string;
    Affiliate1PortalDisplayId: Number;
    Affiliate2PortalDisplayId: Number;
    Affiliate3PortalDisplayId: Number;

    public Affiliate2Name: string;
    public Affiliate3Name: string;
    public BillingStatusId: number;
    public RoundId: number;
    public StatusId: number;
    public ScoreforGoal: number = 0;
    public DateCreated: Date;
    public CRGoalId: number;
    public EstimatiedTimeId: number;
    public PackageId: number;
    public TopLogoId: Number;
    public TopBanerId: Number;
    public UserName: string;
    public Password: string;
    public CPortalAffiliate1: boolean;
    public CPortalAffiliate2: boolean;
    public CPortalAffiliate3: boolean;
    public APortalAffiliate1: boolean;
    public APortalAffiliate2: boolean;
    public APortalAffiliate3: boolean;
    public CommunicationId: Number;
    public ModifyBy: string;
    public RoadmapId: Number;
    public CustomerPortalDisplayId: Number;
    public AffiliatePortalDisplayId: Number;
    public ProgramId: Number;
    public BillingStatusDays: string;
    public DaysInStatus: string;
    public LetterInPortal: string;
    public Pin: string;
    public ProgressId: Number;
    public ScoreRangeId: Number;
    public ImportantInfoIds: string;
    public MemberEmails: string;
    // public RoundName: string;
    // public ProgressName: string;
    public CMStatus: string;
    public BotTeams: string;
    public BotStrategies: string;
}

export enum AffiliatePortalDisplayId {
  CompleteView = 1,
  LineView = 2,
  NameOnly = 3,
  PortalOff = 4,
  CompleteViewAskPerms = 5,
  LineViewAskPerms = 6
}

export enum FileAssignmentId {
  CreditAdviser = 1,
  CaseManager = 2,
  AccountManager = 3,
  RelationshipManager = 4,
  MarketingDirector = 5,
  AccountExecutive = 6
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/models/contact/contact-file-information-dc.model.ts